// MARKETS
export const marketsIdentitites = {
  handicaps: {
    10002: 'CSGO_HANDICAP',
    10012: 'CSGO_HANDICAP_ROUND',
    20002: 'DOTA2_HANDICAP',
  },
  totals: {
    10003: 'CSGO_TOTAL',
    10007: 'CSGO_TOTAL_ODDEVEN',
    10013: 'CSGO_TOTAL_ROUND',
    10103: 'CSGO_TEAM1_TOTAL',
    10113: 'CSGO_TEAM2_TOTAL',
    20003: 'DOTA2_TOTAL',
    20007: 'DOTA2_TOTAL_ODDEVEN',
    20013: 'DOTA2_TOTAL_ROUND',
  },
  winners: {
    10001: 'CSGO_WINNER',
    10111: 'CSGO_WINNER_KNIFE_ROUND',
    10113: 'CSGO_WINNER_OF_FIRST_N_ROUND',
    20001: 'DOTA2_WINNER',
  },
};

export const marketIntervals = {
  1: 'MATCH',
  100: 'Map 1',
  110: 'Map 1 main time',
  200: 'Map 2',
  210: 'Map 2 main time',
  300: 'Map 3',
  310: 'Map 3 main time',
  400: 'Map 4',
  410: 'Map 4 main time',
  500: 'Map 5',
  510: 'Map 5 main time',
};

export const marketsGroups = {
  10001: 'Winner Match',
  10002: 'Handicap',
  10003: 'Total',
  10012: 'Handicap Round',
  10013: 'Total Round',
  20001: 'Winner Match',
  20002: 'Handicap',
  20003: 'Total',
};

// OUTCOMES
export const outcomeIdentities = {
  101: 'Win 1',
  102: 'Draw',
  103: 'Win 2',
  // 104: 'Over',
  104: 'GAMES.OUTCOMES.Over',
  // 105: 'Under',
  105: 'GAMES.OUTCOMES.Under',
  // 106: 'Odd',
  106: 'GAMES.OUTCOMES.Odd',
  // 107: 'Even',
  107: 'GAMES.OUTCOMES.Even',
  108: 'ES.OUTCOMES.Yes',
  109: 'ES.OUTCOMES.No',
};

export function outcomeIdentitiesShort(kind, identity, name) {
  switch (identity) {
    case 101: {
      if (kind === 3) {
        const match = name.match(/\s[^\s]*$/gi);
        if (match && match[0]) {
          return match[0];
        }
      }
      return '1';
    }
    case 102:
      return 'X';
    case 103: {
      if (kind === 3) {
        const match = name.match(/\s[^\s]*$/gi);
        if (match && match[0]) {
          return match[0];
        }
      }
      return '2';
    }
    case 104:
      return 'GAMES.OUTCOMES.OVER_SHORT';
    case 105:
      return 'GAMES.OUTCOMES.UNDER_SHORT';
    case 106:
      return 'GAMES.OUTCOMES.Odd';
    case 107:
      return 'GAMES.OUTCOMES.Even';
    case 108:
      return 'ES.OUTCOMES.Yes';
    case 109:
      return 'ES.OUTCOMES.No';
    default:
      return identity;
  }
}

// BET
export const betStatus = {
  bet: {
    0: 'pending',
    1: 'won',
    2: 'lost',
    3: 'half_win',
    4: 'half_lose',
    5: 'void',
    6: 'refund',
  },
  getPlaceBetStatus: (errorCode) => {
    switch (errorCode) {
      case 0:
        return 'Pending';
      case 1:
        return 'Ok';
      case 2:
        // 2: 'Not enough money',
        return 'RX.BETSLIP.ERRORS.NOT_ENOUGH_MONEY';
      case 4:
        // 4: 'Wrong login'
        return 'RX.BETSLIP.ERRORS.WRONG_LOGIN';
      case 5:
        // 5: 'Outcome limit exceeded'
        return 'RX.BETSLIP.ERRORS.OUTCOME_LIMIT_EXCEEDED';
      case 6:
        // 6: 'Live limit exceeded'
        return 'RX.BETSLIP.ERRORS.LIVE_LIMIT_EXCEEDED';
      case 7:
        // 7: 'Prematch limit exceeded'
        return 'RX.BETSLIP.ERRORS.PREMATCH_LIMIT_EXCEEDED';
      case 8:
        // 8: 'Odd was changed'
        return 'RX.BETSLIP.ODD_WAS_CHANGED';
      case 9:
        // 9: 'Event finished'
        return 'RX.BETSLIP.ERRORS.EVENT_FINISHED';
      case 13:
        // 13: 'Tournament not included in bonus'
        return 'RX.BETSLIP.ERRORS.TOURNAMENT_NOT_INCLUDED_BONUS';
      case 14:
        // 14: 'Player GEO not included in bonus'
        return 'RX.BETSLIP.ERRORS.PLAYER_GEO_NOT_INCLUDED_BONUS';
      case 20:
        // 20: 'Timeout exceeded'
        return 'RX.BETSLIP.ERRORS.TIMEOUT_EXCEEDED';
      case 25:
        // 25: 'User is blocked'
        return 'ES.ERRORS.KINDS.317';
      case 31:
        // 31: 'express_event_uniqueness'
        return 'RX.BETSLIP.ERRORS.EXPRESS_EVENT_UNIQUENESS';
      case 32:
        // 32: 'Outcome not found'
        return 'RX.BETSLIP.ERRORS.OUTCOME_NOT_FOUND';
      case 35:
        // 35: 'Minimum limit not reached'
        return 'RX.BETSLIP.ERRORS.MINIMUM_LIMIT_NOT_REACHED';
      case 36:
        // 36: 'Validation failed'
        return 'RX.BETSLIP.ERRORS.VALIDATION_FAILED';
      case 37:
        return 'RX.BETSLIP.ERRORS.BOTWAR.EXPRESS';
      case 42:
        // 42 'The user’s stake limit has been reached'
        return 'RX.BETSLIP.ERRORS.EXTERNAL_USER_STAKE_LIMIT';
      case 43:
        // 43 'The user loss limit has been reached'
        return 'RX.BETSLIP.ERRORS.EXTERNAL_USER_LOSS_LIMIT';
      case 44:
        // 44 'The bet count limit has been reached'
        return 'RX.BETSLIP.ERRORS.EXTERNAL_BET_COUNT_LIMIT';
      case 45:
        // 45 'The user is self-excluded'
        return 'RX.BETSLIP.ERRORS.EXTERNAL_EXCLUDED';
      case 46:
        // 46 'TThe user is not verified'
        return 'RX.BETSLIP.ERRORS.EXTERNAL_USER_NOT_VERIFIED';
      case 47:
        // 47 'The user is not old enough'
        return 'RX.BETSLIP.ERRORS.EXTERNAL_USER_NOT_OLD_ENOUGH';
      case 50:
        // 50 'Internal error'
        return 'RX.BETSLIP.ERRORS.INTERNAL_ERROR';
      case 60:
        // 60 'Bonus Unacceptable'
        return 'COMMON.BONUS.BONUS_UNACCEPTABLE';
      case 117:
        // 117 'This bet type is not allowed for the selected match.'
        return 'BETSLIP.ERRORS.BET_IS_NOT_ALLOWED';
      case 429:
        // 60 'The number of settled bets on outcome has been exceeded'
        return 'RX.BETSLIP.ERRORS.OUTCOME_BETS_LIMIT_EXCEEDED';
      case 1002:
        // 1002 'Bet declined'
        return 'RX.BETSLIP.ERRORS.BET_DECLINED';
      default:
        // 'Something went wrong. Please try again later or contact support'
        return 'BETSLIP.ERRORS.DEFAULT_MESSAGE';
    }
  },
  iframeMessage: {
    loginErr: {
      statusId: 2,
      text: 'User not logged in',
    },
    notEnoughMoney: {
      statusId: 1,
      text: 'Not enough money',
    },
  },
  ticket: {
    0: 'Pending',
    1: 'Rejected',
    2: 'Placed',
    3: 'Finished',
  },
};

// message for 'not processed' error codes
// 'Bet not processed. Please try again'
const notProcessedMessage = 'BETSLIP.ERRORS.BET_NOT_PROCESSED';

// Error map for output message in 'pro layout' logic
export const errorMap = {
  // 'Your Bet Slip cannot include suspended or closed outcome'
  32: 'BETSLIP.ERRORS.CLOSED_MARKETS',
  // 'You cannot bet less than {{minBet}}'
  35: 'BETSLIP.ERRORS.CANNOT_LESS_THAN',
  // 'Limit exceeded. Please remove one of the outcomes'
  5: 'RX.BETSLIP.ERRORS.OUTCOME_LIMIT_EXCEEDED',
  // 'Odds have changed. To place a bet you need to review and approve changes first'
  8: 'BETSLIP.ERRORS.ODDS_HAVE_CHANGED',
  // 'Your Bet Slip cannot include suspended or closed outcome'
  9: 'BETSLIP.ERRORS.CLOSED_MARKETS',
  // Betbuilder is not available for live events.
  betBuilderCloseError: 'BETBUILDER.CLOSE.ERROR',
  duplicatedError: 'RX.BETSLIP.ERRORS.DUPLICATED_EVENT',
  // 'Validation failed'
  invalidAmount: 'BETSLIP.ERRORS.EMPTY_AMOUNT',
  // 'Your Bet Slip cannot include suspended or closed outcome'
  marketUnavailableError: 'BETSLIP.ERRORS.CLOSED_MARKETS',
  // 'Your bet has reached the limit {setMaxBet}'
  maxBetError: 'BETSLIP.ERRORS.SHOULD_LESS_MAXBET',
  // 'Max odds reached'
  maxOddsReach: 'BETSLIP.NOTICES.MAX_ODDS_REACH',
  outrightError: 'RX.BETSLIP.ERRORS.OUTRIGHT_EVENT',
  // Dynamically add 'notProcessedMessage' for all codes in 'notProcessedErrorsCode'
  ...Object.fromEntries(
    [6, 7, 20, 36, 50, 429] // Error codes for 'not processed' in 'pro layout' logic
      .map((code) => [code, notProcessedMessage]),
  ),
};

// Error map for output message in Quick Bet mode
export const quickBetErrorMap = {
  // 'Minimum quick bet is {{minBet}}'
  35: 'QB.ERRORS.CANNOT_LESS_THAN',
  // 'Limit exceeded'
  5: 'QB.ERRORS.LIMIT_EXCEEDED',
  // 'Odds have changed. Please, try again.'
  8: 'QB.ERRORS.ODDS_HAVE_CHANGED',
  // Dynamically add 'notProcessedMessage' for all codes in 'notProcessedErrorsCode'
  ...Object.fromEntries(
    [6, 7, 9, 20, 32, 36, 50, 429] // Error codes for 'not processed' in 'pro layout' logic
      .map((code) => [code, notProcessedMessage]),
  ),
};

// Error map for output message in Bet Builder mode
export const betBuilderErrorMap = {
  // '500 / Something went wrong. Please try again or try again later.'
  500: 'BETBUILDER.ERROR.CALCULATION',
  // '501 / This content is currently unavailable for Bet Builder.'
  501: 'BETBUILDER.ERROR.STRATEGY',
  // '502 / This outcome is not allowed in a Bet Builder bet.'
  502: 'BETBUILDER.ERROR.INVALID.SELECTIONS',
  // '503 / Bet Builder is not available for this product.'
  503: 'BETBUILDER.ERROR.PARTNER',
  // '504 / Cashout is not available for Bet Builder bets.'
  504: 'BETBUILDER.ERROR.CASHOUT',
  // '505 / Add more Bet Builder outcomes to place a successful bet.'
  505: 'BETBUILDER.ERROR.ONEOUTCOME',
  // Some of the outcomes are not available
  506: 'SHAREBET.ERROR.SOME_MARKETS',
};

// EVENT
export const eventStatus = {
  ACTIVE: 3,
  OVER: 5,
  SUSPENDED: 1,
};
export const eventAction = {
  CREATE: 1,
  DELETE: 3,
  UPDATE: 2,
};

export const marketGroups = {
  HANDICAPS: {
    ids: [3],
    name: 'Match Handicap',
    tKey: 'ES.MARKETS.HANDICAP',
  },
  TOTALS: {
    ids: [4],
    name: 'Match Total',
    tKey: 'ES.MARKETS.TOTAL',
  },
  WINNERS: {
    ids: [1, 2],
    name: 'Match Winner',
    tKey: 'ES.MARKETS.RESULT_OF_THE_MATCH',
  },
};

export const mainMarketsGroups = {
  0: 'ES.MARKETS.RESULT_OF_THE_MATCH',
  1: 'ES.MARKETS.HANDICAP',
  2: 'ES.MARKETS.TOTAL',
};

export const marketsKinds = {
  1: {
    name: 'WINNER_2WAY',
    outcomes: {
      101: {
        name: {
          en: '{team1}',
          ru: '{team1}',
          uk: '{team1}',
        },
        shortName: {
          en: '1',
          ru: '1',
          uk: '1',
        },
        value: 0,
      },
      103: {
        name: {
          en: '{team2}',
          ru: '{team2}',
          uk: '{team2}',
        },
        shortName: {
          en: '2',
          ru: '2',
          uk: '2',
        },
        value: 0,
      },
    },
  },
  10: {
    name: 'YES_NO',
    outcomes: {
      108: {
        name: {
          en: 'Yes',
          ru: 'Да',
          uk: 'Так',
        },
        shortName: {
          en: 'Yes',
          ru: 'Да',
          uk: 'Так',
        },
        value: 0,
      },
      109: {
        name: {
          en: 'No',
          ru: 'Нет',
          uk: 'Ні',
        },
        shortName: {
          en: 'No',
          ru: 'Нет',
          uk: 'Ні',
        },
        value: 0,
      },
    },
  },
  14: {
    name: 'EXACT_TOTAL',
    outcomes: {
      110: {
        name: {
          en: '{param2}',
          ru: '{param2}',
          uk: '{param2}',
        },
        shortName: {
          en: '{param2}',
          ru: '{param2}',
          uk: '{param2}',
        },
        value: 1,
      },
    },
  },
  15: {
    name: 'RACE_TO',
    outcomes: {
      101: {
        name: {
          en: '{team1}',
          ru: '{team1}',
          uk: '{team1}',
        },
        shortName: {
          en: '{team1}',
          ru: '{team1}',
          uk: '{team1}',
        },
        value: 0,
      },
      103: {
        name: {
          en: '{team2}',
          ru: '{team2}',
          uk: '{team2}',
        },
        shortName: {
          en: '{team2}',
          ru: '{team2}',
          uk: '{team2}',
        },
        value: 0,
      },
    },
  },
  16: {
    name: 'HEROES',
    outcomes: {
      200: {
        name: {
          en: '{param2}',
          ru: '{param2}',
          uk: '{param2}',
        },
        shortName: {
          en: '{param2}',
          ru: '{param2}',
          uk: '{param2}',
        },
        value: 1,
      },
    },
  },
  17: {
    name: 'CORRECT_SCORE',
    outcomes: {
      111: {
        name: {
          en: '{param2}',
          ru: '{param2}',
          uk: '{param2}',
        },
        shortName: {
          en: '{param2}',
          ru: '{param2}',
          uk: '{param2}',
        },
        value: 1,
      },
    },
  },
  18: {
    name: 'METHOD_OF_QUALIFYING',
    outcomes: {
      123: {
        name: {
          en: '{team1} after a main time',
          ru: '{team1} после основного времени',
        },
        shortName: {
          en: '1 after a main time',
          ru: '1 после основного времени',
        },
        value: 0,
      },
      124: {
        name: {
          en: '{team1} after an overtime',
          ru: '{team1} после овертайма',
        },
        shortName: {
          en: '1 after an overtime',
          ru: '1 после овертайма',
        },
        value: 0,
      },
      125: {
        name: {
          en: '{team1} after penalties',
          ru: '{team1} после пенальти',
        },
        shortName: {
          en: '1 after penalties',
          ru: '1 после пенальти',
        },
        value: 0,
      },
      126: {
        name: {
          en: '{team2} after a main time',
          ru: '{team2} после основного времени',
        },
        shortName: {
          en: '2 after a main time',
          ru: '2 после основного времени',
        },
        value: 0,
      },
      127: {
        name: {
          en: '{team2} after an overtime',
          ru: '{team2} после овертайма',
        },
        shortName: {
          en: '2 after an overtime',
          ru: '2 после овертайма',
        },
        value: 0,
      },
      128: {
        name: {
          en: '{team2} after penalties',
          ru: '{team2} после пенальти',
        },
        shortName: {
          en: '2 after penalties',
          ru: '2 после пенальти',
        },
        value: 0,
      },
    },
  },
  19: {
    name: 'WHO_WILL_SCORE_GOAL_NUMBER_N_3WAYS',
    outcomes: {
      100: {
        name: {
          en: 'None',
          ru: 'Никто',
        },
        shortName: {
          en: 'N',
          ru: 'Н',
        },
        value: 0,
      },
      101: {
        name: {
          en: '{team1}',
          ru: '{team1}',
        },
        shortName: {
          en: '1',
          ru: '1',
        },
        value: 0,
      },
      102: {
        name: {
          en: '{team2}',
          ru: '{team2}',
        },
        shortName: {
          en: '2',
          ru: '2',
        },
        value: 0,
      },
    },
  },
  2: {
    name: 'WINNER_3WAY',
    outcomes: {
      101: {
        name: {
          en: '{team1}',
          ru: '{team1}',
          uk: '{team1}',
        },
        shortName: {
          en: '1',
          ru: '1',
          uk: '1',
        },
        value: 0,
      },
      102: {
        name: {
          en: 'Draw',
          ru: 'Ничья',
          uk: 'Нічия',
        },
        shortName: {
          en: 'X',
          ru: 'X',
          uk: 'X',
        },
        value: 0,
      },
      103: {
        name: {
          en: '{team2}',
          ru: '{team2}',
          uk: '{team2}',
        },
        shortName: {
          en: '2',
          ru: '2',
          uk: '2',
        },
        value: 0,
      },
    },
  },
  20: {
    name: 'WHO_WILL_SCORE_LAST_GOAL_3WAYS',
    outcomes: {
      100: {
        name: {
          en: 'None',
          ru: 'Никто',
        },
        shortName: {
          en: 'N',
          ru: 'Н',
        },
        value: 0,
      },
      101: {
        name: {
          en: '{team1}',
          ru: '{team1}',
        },
        shortName: {
          en: '1',
          ru: '1',
        },
        value: 0,
      },
      102: {
        name: {
          en: '{team2}',
          ru: '{team2}',
        },
        shortName: {
          en: '2',
          ru: '2',
        },
        value: 0,
      },
    },
  },
  21: {
    name: 'MATCH_RESULT_AND_TOTAL',
    outcomes: {
      115: {
        name: {
          en: '{team1} and over {param1}',
          ru: '{team1} и больше {param1}',
        },
        shortName: {
          en: '1 and over {param1}',
          ru: '1 и больше {param1}',
        },
        value: 0,
      },
      116: {
        name: {
          en: '{team1} and under {param1}',
          ru: '{team1} и меньше {param1}',
        },
        shortName: {
          en: '1 and under {param1}',
          ru: '1 и меньше {param1}',
        },
        value: 0,
      },
      117: {
        name: {
          en: '{team2} and over {param1}',
          ru: '{team2} и больше {param1}',
        },
        shortName: {
          en: '2 and over {param1}',
          ru: '2 и больше {param1}',
        },
        value: 0,
      },
      118: {
        name: {
          en: '{team2} and under {param1}',
          ru: '{team2} и меньше {param1}',
        },
        shortName: {
          en: '2 and under {param1}',
          ru: '2 и меньше {param1}',
        },
        value: 0,
      },
      129: {
        name: {
          en: 'X1 and over {param1}',
          ru: 'X1 и больше {param1}',
        },
        shortName: {
          en: 'X1 and over {param1}',
          ru: 'X1 и больше {param1}',
        },
        value: 0,
      },
      130: {
        name: {
          en: 'X1 and under {param1}',
          ru: 'X1 и меньше {param1}',
        },
        shortName: {
          en: 'X1 and under {param1}',
          ru: 'X1 и меньше {param1}',
        },
        value: 0,
      },
      131: {
        name: {
          en: 'X2 and over {param1}',
          ru: 'X2 и больше {param1}',
        },
        shortName: {
          en: 'X2 and over {param1}',
          ru: 'X2 и больше {param1}',
        },
        value: 0,
      },
      132: {
        name: {
          en: 'X2 and under {param1}',
          ru: 'X2 и меньше {param1}',
        },
        shortName: {
          en: 'X2 and under {param1}',
          ru: 'X2 и меньше {param1}',
        },
        value: 0,
      },
      133: {
        name: {
          en: 'Draw and over {param1}',
          ru: 'Ничья и больше {param1}',
        },
        shortName: {
          en: 'X and over {param1}',
          ru: 'X и больше {param1}',
        },
        value: 0,
      },
      134: {
        name: {
          en: 'Draw and under {param1}',
          ru: 'Ничья и меньше {param1}',
        },
        shortName: {
          en: 'X and under {param1}',
          ru: 'X и меньше {param1}',
        },
        value: 0,
      },
    },
  },
  3: {
    name: 'HANDICAP',
    outcomes: {
      101: {
        name: {
          en: '{team1} {param1}',
          ru: '{team1} {param1}',
          uk: '{team1} {param1}',
        },
        shortName: {
          en: '{param1}',
          ru: '{param1}',
          uk: '{param1}',
        },
        value: 0,
      },
      103: {
        name: {
          en: '{team2} {param1}',
          ru: '{team2} {param1}',
          uk: '{team2} {param1}',
        },
        shortName: {
          en: '{param1}',
          ru: '{param1}',
          uk: '{param1}',
        },
        value: 0,
      },
    },
  },
  4: {
    name: 'TOTAL',
    outcomes: {
      104: {
        name: {
          en: 'Over {param1}',
          ru: 'Больше {param1}',
          uk: 'Більше {param1}',
        },
        shortName: {
          en: 'O {param1}',
          ru: 'Б {param1}',
          uk: 'Б {param1}',
        },
        value: 0,
      },
      105: {
        name: {
          en: 'Under {param1}',
          ru: 'Меньше {param1}',
          uk: 'Менше {param1}',
        },
        shortName: {
          en: 'U {param1}',
          ru: 'М {param1}',
          uk: 'М {param1}',
        },
        value: 0,
      },
    },
  },
  5: {
    name: 'ODD_EVEN',
    outcomes: {
      106: {
        name: {
          en: 'Odd',
          ru: 'Нечетный',
          uk: 'Непарний',
        },
        shortName: {
          en: 'O',
          ru: 'Н',
          uk: 'Н',
        },
        value: 0,
      },
      107: {
        name: {
          en: 'Even',
          ru: 'Четный',
          uk: 'Парний',
        },
        shortName: {
          en: 'E',
          ru: 'Ч',
          uk: 'Ч',
        },
        value: 0,
      },
    },
  },
  6: {
    name: 'FIRST_N_SUB_INTERVALS_WINNER',
    outcomes: {
      101: {
        name: {
          en: '{team1}',
          ru: '{team1}',
          uk: '{team1}',
        },
        shortName: {
          en: '1',
          ru: '1',
          uk: '1',
        },
        value: 0,
      },
      103: {
        name: {
          en: '{team2}',
          ru: '{team2}',
          uk: '{team2}',
        },
        shortName: {
          en: '2',
          ru: '2',
          uk: '2',
        },
        value: 0,
      },
    },
  },
  66: {
    name: 'WHO_WILL_BE_HIGHER',
    outcomes: {
      101: {
        name: {
          en: '1-st better',
          ru: '1-й выше',
          uk: '1',
        },
        shortName: {
          en: '1',
          ru: '1',
          uk: '1',
        },
        value: 0,
      },
      103: {
        name: {
          en: '2-nd better',
          ru: '2-й выше',
          uk: '2',
        },
        shortName: {
          en: '2',
          ru: '2',
          uk: '2',
        },
        value: 0,
      },
    },
  },
  7: {
    name: 'DOUBLE_CHANCE',
    outcomes: {
      112: {
        name: {
          en: '1X',
          ru: '1X',
          uk: '1X',
        },
        shortName: {
          en: '1X',
          ru: '1X',
          uk: '1X',
        },
        value: 0,
      },
      113: {
        name: {
          en: '12',
          ru: '12',
          uk: '12',
        },
        shortName: {
          en: '12',
          ru: '12',
          uk: '12',
        },
        value: 0,
      },
      114: {
        name: {
          en: 'X2',
          ru: 'X2',
          uk: 'X2',
        },
        shortName: {
          en: 'X2',
          ru: 'X2',
          uk: 'X2',
        },
        value: 0,
      },
    },
  },
  8: {
    name: 'WINNER_2WAY_AND_TOTAL',
    outcomes: {
      115: {
        name: {
          en: '{team1} win and Over {param1}',
          ru: '{team1} победит и Больше {param1}',
          uk: '{team1} переможе та Більше {param1}',
        },
        shortName: {
          en: '1 & O {param1}',
          ru: '1 & Б {param1}',
          uk: '1 & Б {param1}',
        },
        value: 0,
      },
      116: {
        name: {
          en: '{team1} win and Under {param1}',
          ru: '{team1} победит и Меньше {param1}',
          uk: '{team1} переможе та Менше {param1}',
        },
        shortName: {
          en: '1 & U {param1}',
          ru: '1 & М {param1}',
          uk: '1 & М {param1}',
        },
        value: 0,
      },
      117: {
        name: {
          en: '{team2} win and Over {param1}',
          ru: '{team2} победит и Больше {param1}',
          uk: '{team2} переможе та Більше {param1}',
        },
        shortName: {
          en: '2 & O {param1}',
          ru: '2 & Б {param1}',
          uk: '2 & Б {param1}',
        },
        value: 0,
      },
      118: {
        name: {
          en: '{team2} win and Under {param1}',
          ru: '{team2} победит и Меньше {param1}',
          uk: '{team2} переможе та Менше {param1}',
        },
        shortName: {
          en: '2 & U {param1}',
          ru: '2 & М {param1}',
          uk: '2 & М {param1}',
        },
        value: 0,
      },
    },
  },
  9: {
    name: 'METHOD_OF_WINNER',
    outcomes: {
      119: {
        name: {
          en: 'Team killed',
          ru: 'Команда убита',
          uk: 'Команда вбита',
        },
        shortName: {
          en: 'Team killed',
          ru: 'Команда убита',
          uk: 'Команда вбита',
        },
        value: 0,
      },
      120: {
        name: {
          en: 'Bomb defused',
          ru: 'Бомба обезврежена',
          uk: 'Бомба знешкоджена',
        },
        shortName: {
          en: 'Bomb defused',
          ru: 'Бомба обезврежена',
          uk: 'Бомба знешкоджена',
        },
        value: 0,
      },
      121: {
        name: {
          en: 'Bomb exploded',
          ru: 'Взорвана бомба',
          uk: 'Вибухнула бомба',
        },
        shortName: {
          en: 'Bomb exploded',
          ru: 'Взорвана бомба',
          uk: 'Вибухнула бомба',
        },
        value: 0,
      },
      122: {
        name: {
          en: 'Time over',
          ru: 'Время вышло',
          uk: 'Час закінчився',
        },
        shortName: {
          en: 'Time over',
          ru: 'Время вышло',
          uk: 'Час закінчився',
        },
        value: 0,
      },
    },
  },
};

// export const outrightIdentities = {
//     5056: 'ES.OUTRIGHT_TOURNAMENT_WINNER',
//     5057: 'ES.OUTRIGHT_WILL_TAKE_N_PLACE',
//     5058: 'ES.OUTRIGHT_GROUP_EXIT',
//     5059: 'ES.OUTRIGHT_WILL_REACH_QUARTER_FINAL',
//     5060: 'ES.OUTRIGHT_WILL_REACH_SEMI_FINAL',
//     5061: 'ES.OUTRIGHT_WILL_REACH_FINAL',
//     5062: 'ES.OUTRIGHT_TAKEN_PLACE',
//     5063: 'ES.OUTRIGHT_WILL_TAKE_PLACE',
//     5064: 'ES.OUTRIGHT_WILL_TAKE_LAST_PLACE',
//     5065: 'ES.OUTRIGHT_WILL_BE_RELEGATE',
//     5066: 'ES.OUTRIGHT_WHO_WILL_BE_HIGHER',
// };

export const outrightIdentities = {
  '0103': 'ES.OUTRIGHT.TOURNAMENT_WINNER', // Победитель // Winner (Football)
  '0104': 'ES.OUTRIGHT.WILL_TAKE_N_PLACE', // Победитель // Winner
  '0105': 'ES.OUTRIGHT.GROUP_EXIT', // Займет N-е место // Will take N place (Football)
  '0106': 'ES.OUTRIGHT.WILL_REACH_QUARTER_FINAL', // Займет N-е место // Will take N place
  '0107': 'ES.OUTRIGHT.WILL_REACH_SEMI_FINAL', // Выйдет из группы // Will qualify from the group (Football)
  '0108': 'ES.OUTRIGHT.WILL_REACH_FINAL', // Выйдет из группы // Will qualify from the group
  '0109': 'ES.OUTRIGHT.TAKEN_PLACE', // Выйдет в 1/4 финала // Will reach the Quarterfinals (Football)
  '0110': 'ES.OUTRIGHT.WILL_TAKE_PLACE', // Выйдет в 1/4 финала // Will reach the Quarterfinals
  '0111': 'ES.OUTRIGHT.WILL_TAKE_LAST_PLACE', // Выйдет в 1/2 финала // Will reach the Semifinals (Football)
  '0112': 'ES.OUTRIGHT.WILL_BE_RELEGATE', // Выйдет в 1/2 финала // Will reach the Semifinals
  '0113': 'ES.OUTRIGHT.WHO_WILL_BE_HIGHER', // Выйдет в финал //  Will reach the Final (Football)
  5056: 'ES.OUTRIGHT.TOURNAMENT_WINNER', // Выйдет в финал //  Will reach the Final
  5057: 'ES.OUTRIGHT.WILL_TAKE_N_PLACE', // Taken place // Taken place (Football)
  5058: 'ES.OUTRIGHT.GROUP_EXIT', // Taken place // Taken place
  5059: 'ES.OUTRIGHT.WILL_REACH_QUARTER_FINAL', // Займет место // Will take place (Football)
  5060: 'ES.OUTRIGHT.WILL_REACH_SEMI_FINAL', // Займет место // Will take place
  5061: 'ES.OUTRIGHT.WILL_REACH_FINAL', // Займет последнее место // Will finish bottom (Football)
  5062: 'ES.OUTRIGHT.TAKEN_PLACE', // Займет последнее место // Will finish bottom
  5063: 'ES.OUTRIGHT.WILL_TAKE_PLACE', // Вылетит // Will be relegated (Football)
  5064: 'ES.OUTRIGHT.WILL_TAKE_LAST_PLACE', // Вылетит // Will be relegated
  5065: 'ES.OUTRIGHT.WILL_BE_RELEGATE', // Кто выше // Will be higher (edited) (Football)
  5066: 'ES.OUTRIGHT.WHO_WILL_BE_HIGHER', // Кто выше // Will be higher (edited)
};
